/**
 * Conteggio ricorsivo file sotto una cartella (solo Electron / window.electronFS).
 */
export function countFilesRecursiveElectron(rootPath: string): number {
  const fs = typeof window !== 'undefined' ? window.electronFS : undefined;
  if (!fs || !rootPath) return 0;
  if (!fs.directoryExists(rootPath) && !fs.pathExists(rootPath)) return 0;

  const efs = fs;

  function walk(dir: string): number {
    let n = 0;
    try {
      const entries = efs.readDirectory(dir);
      for (const e of entries) {
        const full = efs.joinPath(dir, e.name);
        if (e.kind === 'file') {
          n += 1;
        } else if (e.kind === 'directory') {
          if (efs.directoryExists(full)) {
            n += walk(full);
          }
        }
      }
    } catch {
      // permessi o path non accessibile
    }
    return n;
  }

  return walk(rootPath);
}
